export enum SocialLayout {
    FB1 = '0',
}

export enum DisplayLayout {
    DISPLAY_LISTING_STANDARD = '1',
}

export enum LayoutFlag {
    NO_AGENT_PHOTO = '2',
}

export const AllLayouts = { ...SocialLayout, ...DisplayLayout, ...LayoutFlag };

export const getPipelineNameFromValue = (value: string): string | null => {
    const key = Object.keys(AllLayouts).find(
        (k) => AllLayouts[k as keyof typeof AllLayouts] === value
    );
    return key ? key.toLowerCase() : null;
};

type OverlappingValues =
    | Extract<`${SocialLayout}`, `${DisplayLayout}`>
    | Extract<`${SocialLayout}`, `${LayoutFlag}`>
    | Extract<`${DisplayLayout}`, `${LayoutFlag}`>;

export type CheckUniqueness = {}[OverlappingValues];
